import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], loading: false },
  orgs: { data: [], pageSize: 0, pageNum: 0, total: 0, loading: false },
  savedOrgs: { data: [], loading: false },
  dialog: { visible: false, loading: false, type: '', title: '' },
  confirm: { title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
